document.addEventListener("DOMContentLoaded", () => {
  const players = initializePlyrPlayers();
  initializeSwiperSlider(players);
});

function initializePlyrPlayers() {
  return Array.from(document.querySelectorAll(".plyr__video-embed"))
    .map((container) => {
      const video = container.querySelector("video");
      if (!video) return null;

      // Ensure required attributes for mobile playback
      video.setAttribute("playsinline", "");
      video.setAttribute("webkit-playsinline", "");
      video.muted = true; // Required for autoplay

      const player = new Plyr(video, {
        controls: [
          "play-large",
          "play",
          "progress",
          "current-time",
          "mute",
          "volume",
          "fullscreen",
        ],
        hideControls: false, // Changed to false to ensure controls are always available
        clickToPlay: false, // We'll handle this manually
        storage: { enabled: false },
        autoplay: false, // We'll handle autoplay manually
      });

      // Store references
      player.container = container;
      player.videoElement = video;

      // Prevent control clicks from bubbling to slide
      container.querySelectorAll(".plyr__control").forEach((control) => {
        control.addEventListener("click", (e) => {
          e.stopPropagation();
        });
      });

      return player;
    })
    .filter((player) => player !== null);
}

function initializeSwiperSlider(players) {
  const slider = document.querySelector(".slider-hero-video");
  if (!slider) return;

  const swiper = new Swiper(".slider-hero-video", {
    loop: true,
    speed: 1000,
    effect: "coverflow",
    centeredSlides: true,
    slidesPerView: "auto",
    spaceBetween: 5,
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: false,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    on: {
      init: function () {
        playActiveVideo(this, players);
        addVideoAltText();
      },
      slideChangeTransitionStart: () => stopAllVideos(players),
      slideChangeTransitionEnd: function () {
        playActiveVideo(this, players);
      },
    },
  });

  const nextBtn = document.querySelector(
    ".slider-hero-video .swiper-button-next"
  );
  const prevBtn = document.querySelector(
    ".slider-hero-video .swiper-button-prev"
  );

  if (nextBtn) {
    nextBtn.addEventListener("click", () => {
      playActiveVideo(swiper, players);
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener("click", () => {
      playActiveVideo(swiper, players);
    });
  }
  setupSlideClickHandlers(swiper, players);
}

function setupSlideClickHandlers(swiper, players) {
  document.querySelectorAll(".clickVid").forEach((slide) => {
    slide.addEventListener("click", function (e) {
      if (!e.target.closest(".plyr__controls")) {
        const visible = getVisibleSlides(swiper);

        if (this === visible.left) {
          swiper.slidePrev();
        } else if (this === visible.right) {
          swiper.slideNext();
        } else if (this === visible.center) {
          const video = this.querySelector("video");
          if (video) {
            const matchedPlayers = findPlayerForVideo(players, video);
            if (matchedPlayers) {
              toggleVideoPlayback(matchedPlayers);
            }
          }
        }
      }
    });
  });
}

function playActiveVideo(swiper, players) {
  const activeSlide = swiper.slides[swiper.activeIndex];
  if (!activeSlide) return;

  const video = activeSlide.querySelector("video");
  if (!video) return;

  const matchedPlayers = findPlayerForVideo(players, video);
  if (!matchedPlayers.length) return;

  matchedPlayers.forEach((player) => {
    const parent = player.videoElement.closest(".desktop-video");
    const mobilePlayer = parent.nextElementSibling;
    const mobileVideo = mobilePlayer?.querySelector("video");
    if(mobileVideo){
      mobileVideo.muted = true;
      mobileVideo.autoplay = true;
      mobileVideo.play();
    }
    
    player.videoElement.muted = true;
    player.videoElement.autoplay = true;
    player.play();
    player.autoplay = true;
  });
}

function stopAllVideos(players) {
  players.forEach((player) => {
    if (player && !player.paused) {
      player.pause();
    }
  });
}

// Helper functions
function getVisibleSlides(swiper) {
  const slides = Array.from(swiper.slides);
  const centerIndex = swiper.activeIndex;

  return {
    left: slides[(centerIndex - 1 + slides.length) % slides.length],
    center: slides[centerIndex],
    right: slides[(centerIndex + 1) % slides.length],
  };
}

function findPlayerForVideo(players, videoElement) {
  return players.filter((player) => {
    return player.videoElement === videoElement;
  });
}

function toggleVideoPlayback(players) {
  players.forEach((player) => {
    if (player.paused) {
      player.play();
    } else {
      player.pause();
    }
  });
}

function addVideoAltText() {
  document.querySelectorAll(".swiper-slide video").forEach((video, index) => {
    const posterImage = video.querySelector("img");
    if (posterImage) {
      posterImage.setAttribute("alt", `Video ${index + 1} preview image`);
    }
    video.setAttribute("aria-label", `Video ${index + 1}`);
  });
}
